import { getBackOfficeEntityDataSource } from './index';
import type { IInwinkEntityDataSourceOptions } from '@@api/base/datasource';

export function customerEntityViewDataSource(customerid: string, options?: IInwinkEntityDataSourceOptions) {
    return getBackOfficeEntityDataSource<any>(customerid + "/", "customerentityview", "CustomerEntityView", options);
}
